import React from "react";
import Avatar from "@mui/material/Avatar";
import { MyContextSupply } from "../../Context";
import { NavLink, useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { GrUserExpert, GrUserAdmin } from "react-icons/gr";
import { RiShoppingBag3Line } from "react-icons/ri";
import { MdOutlineFestival } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "./rightheader.css";
import AdminValidation from "./AdminValidation";

const Rightheader = ({
  toggleAdminLinkClick,
  inputValue,
  setInputValue,
  isAdminRouteClick,
  setIsAdminRouteClick,
  setDrawerOpen,
  handleClose,
}) => {
  const { account, token, isAdmin, logoutUser, toggleRunPath } =
    MyContextSupply();
  const navigate = useNavigate();

  const { fname } = account && account;

  return (
    <>
      <div className="rightheader">
        <div className="right_nav">
          {account !== undefined ? (
            <Avatar className="avtar" style={{ background: "blue" }}>
              {fname && fname[0]?.toUpperCase()}
            </Avatar>
          ) : (
            <Avatar className="avtar" />
          )}
          {account ? (
            <h4 style={{ marginTop: "5px", textTransform: "capitalize" }}>
              {fname}
            </h4>
          ) : (
            <h3></h3>
          )}
        </div>
        <div className="nav_btn">
          <NavLink
            to="/"
            onClick={() => {
              toggleRunPath();
              setDrawerOpen(false);
            }}
          >
            <BiHomeAlt style={{ marginRight: "4px" }} />
            Home
          </NavLink>
          <NavLink
            to="/festival/launches/products"
            onClick={() => {
              toggleRunPath();
              setDrawerOpen(false);
            }}
          >
            <MdOutlineFestival style={{ marginRight: "4px" }} />
            Festive latest launches
          </NavLink>

          <NavLink
            to="/buynow"
            onClick={() => {
              toggleRunPath();
              setDrawerOpen(false);
            }}
          >
            <RiShoppingBag3Line style={{ marginRight: "4px" }} /> Order to
            Purchase
          </NavLink>

          <Divider />
          <div className="flag">
            <p>Settings</p>
          </div>

          {token.length !== 0 ? (
            <>
              <NavLink
                to="/personalinfo"
                onClick={() => {
                  toggleRunPath();
                  setDrawerOpen(false);
                }}
              >
                <GrUserExpert style={{ marginRight: "6px" }} />
                My Account
              </NavLink>
              {isAdmin && (
                <div
                  className="admin-dashboard-navigation"
                  style={{ marginBottom: "10px" }}
                >
                  <div
                    onClick={() => {
                      toggleAdminLinkClick();
                      toggleRunPath();
                    }}
                  >
                    <GrUserAdmin style={{ marginRight: "4px" }} /> Admin
                    Dashboard
                  </div>
                  <AdminValidation
                    isAdminRouteClick={isAdminRouteClick}
                    setIsAdminRouteClick={setIsAdminRouteClick}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    handleClose={handleClose}
                    setDrawerOpen={setDrawerOpen}
                  />
                </div>
              )}
              <button
                onClick={() => {
                  logoutUser(navigate);
                  toggleRunPath();
                  setDrawerOpen(false);
                }}
                className="logout-btn"
              >
                <LogoutIcon />
                Logout
              </button>
            </>
          ) : (
            <NavLink
              to="/login"
              onClick={() => {
                toggleRunPath();
                setDrawerOpen(false);
              }}
            >
              Login
            </NavLink>
          )}
        </div>
      </div>
    </>
  );
};

export default Rightheader;

// {token.length !== 0 && isAdmin && (
//   <NavLink
//     to="/admin"
//     style={{
//       textDecoration: "none",
//       color: "black",
//       fontWeight: "bold",
//     }}
//     onClick={handleClose}
//   >
//     <MenuItem>
//       <GrUserAdmin style={{ marginRight: "5px" }} /> Admin Dashboard
//     </MenuItem>
//   </NavLink>
// )}
